import { USER_DATA_RECEIVED, USER_DATA_UNLOADED, USER_INFO_RECEIVED, USER_INFO_UNLOADED, USER_DEVICES_RECEIVED, USER_RESTOREPOINT, USER_DEVICES_DELETED, USER_DEVICES_UNLOADED , PERSON_SAVED, PRIMARY_SAVED, PARTNER_SAVED, BOTH_USER_SAVED } from './types'

export default function user(state = {loading: true}, action = {}){
  switch (action.type) {
    case USER_DATA_RECEIVED:
      return {
        ...state,
        loading: false,
        ...action.user_data
      }
    case USER_DATA_UNLOADED:
      return {
        ...state,
        loading: false,
        user_data: []
      }
    case USER_INFO_RECEIVED:
      return {
        ...state,
        loading: false,
        ...action.user_info
      }
    case USER_INFO_UNLOADED:
      return {
        ...state,
        loading: false,
        user_info: []
      }
    case USER_RESTOREPOINT:
      return {
        ...state, 
        restorePoint: action.restorePoint
      } 
    case BOTH_USER_SAVED:
      return {
        ...state,
        loading: false,
        primary: action.data[0],
        partner: action.data[1]
      }
    case PRIMARY_SAVED:
      return {
        ...state,
        loading: false,
        primary: action.data
      }
    case PARTNER_SAVED:
      return {
        ...state,
        loading: false,
        partner: action.data
      }
    case PERSON_SAVED:
      let isEdit = false
      let _people_state = state.people.map( v => {
        if(v.id === action.data.id){
          isEdit = true
          return action.data
        }else{
          return v
        }
      })
      if(!isEdit){
        _people_state = [action.data, ...state.people]
      }
      return {
        ...state,
        people: _people_state
      }
    case USER_DEVICES_RECEIVED:
      return {
        ...state,
        loading: false,
        user_devices: action.user_devices
      }
    case USER_DEVICES_UNLOADED:
      return {
        ...state,
        loading: false,
        user_devices: []
      }
    case USER_DEVICES_DELETED:
      return {
        ...state,
        loading: false,
        user_devices: state.user_devices.filter( v => v.token !== action.code )
      }
      //return state.user_devices.filter( v => v.token !== action.code )
    default:
      return state;
  }
}
